import type { CustomerOrderDetail, OrderFulfillmentStatus } from '@repo/api-contracts';
import type { QuoteDocumentDestination } from '@/shared/ui';

type OrderDestination = CustomerOrderDetail['destinations'][number];

/** 배송지를 바꿀 수 있는 진행 단계 — 배송 완료 전. 배송 중이어도 송장이 없는 배송지는 바꿀 수 있다(SUPER-86 spec §5-4). */
const EDITABLE_FULFILLMENT: ReadonlySet<OrderFulfillmentStatus> = new Set([
  'WAITING',
  'IN_PRODUCTION',
  'SHIPPED',
]);

/**
 * 고객이 이 배송지 주소를 바꿀 수 있는지(SUPER-86 spec §5-4, D11) — 결제 완료·배송 완료 전·처리 중 취소 요청 없음이고 그 배송지에
 * 송장이 없을 때. 서버(`OrderAddressService`)와 같은 조건이라 버튼이 보이면 상태 충돌 없이 보낼 수 있다.
 */
export const canChangeDestinationAddress = (
  order: CustomerOrderDetail,
  destination: OrderDestination,
): boolean =>
  order.status === 'PAID' &&
  order.pendingCancelRequest === null &&
  EDITABLE_FULFILLMENT.has(order.fulfillmentStatus) &&
  destination.shipments.length === 0;

/** 주문 배송지 → 견적서 배송지 표 한 줄 — 배송비 칸은 복사해 온 견적 배송지 id 로 발행본 배송비 줄과 맞춘다. */
export const orderDestinationsForDocument = (
  destinations: CustomerOrderDetail['destinations'],
): QuoteDocumentDestination[] =>
  destinations.map(({ quoteDestinationId, shippingAddress, quantity, sizes }) => ({
    quoteDestinationId,
    ...shippingAddress,
    quantity,
    sizes,
  }));
